module.exports = "<div class=\"confirm-button\" ng-class=\"{flipped: confirmButton.isFlipped}\">\r\n  <div class=\"front\" ng-class=\"confirmButton.frontStyle\">\r\n    {{confirmButton.frontLabel}}\r\n    <!--<span ng-bind=\"confirmButton.defs.label\"></span>-->\r\n  </div>\r\n  <div class=\"back\" ng-class=\"confirmButton.backStyle\">\r\n    <div class=\"loading-state-content\">\r\n      <span>{{confirmButton.backLabel}}</span>\r\n      <ion-spinner icon=\"dots\" ng-show=\"confirmButton.isLoading()\"></ion-spinner>\r\n    </div>\r\n  </div>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/js/core-components/transforming-buttons/confirm-button.html
// module id = 2949
// module chunks = 0